// Lightweight event sink for storefront UX failures we want to keep an
// eye on but don't have a dedicated analytics library for yet. Each call
// goes to:
//   1. console (always — surfaces in dev tools and any browser-error
//      collector the team wires later)
//   2. window.dataLayer.push — if a GTM container is present
//   3. window.gtag('event', ...) — if GA4 is present
//
// Designed so analytics can be added later by simply loading the vendor
// snippet; no call sites need to change.

const isObject = (v) => v && typeof v === 'object' && !Array.isArray(v);

export const trackEvent = (name, payload = {}) => {
    if (!name) return;
    const safePayload = isObject(payload) ? payload : { value: payload };
    const event = { event: name, ...safePayload, ts: Date.now() };

    try {
        if (typeof console !== 'undefined' && console.info) {
            console.info(`[telemetry] ${name}`, safePayload);
        }
    } catch (_) { /* ignore */ }

    try {
        if (typeof window !== 'undefined') {
            if (Array.isArray(window.dataLayer)) {
                window.dataLayer.push(event);
            }
            if (typeof window.gtag === 'function') {
                window.gtag('event', name, safePayload);
            }
        }
    } catch (_) { /* never let telemetry break the app */ }
};

// Common payload shape for payment failures: keep keys consistent so a
// dashboard query can group across event names.
export const trackPaymentFailure = (name, { orderId, provider, status, reason } = {}) => {
    trackEvent(name, {
        order_id: orderId ?? null,
        provider: provider ?? null,
        http_status: status ?? null,
        reason: reason ?? null,
    });
};

export default trackEvent;
